// DF-0001 - A/B Test Change
(function initDF0001() {
  const root = document.querySelector("[data-df-0001]");
  if (!root) return;

  const mobileQuery = window.matchMedia("(max-width: 1023px)");
  const pdpBuy = document.querySelector(".pdp-buy");
  const atcSlot = root.querySelector("[data-df-0001-atc-slot]");
  const cards = Array.from(root.querySelectorAll("[data-df-0001-card]"));
  const selectionMode = root.getAttribute("data-df-0001-selection-mode") || "quantity";
  const placeholder = document.createComment("DF-0001 pdp-buy original position");

  if (!pdpBuy || !atcSlot || !cards.length) return;

  document.body.classList.add("has-df-0001");
  pdpBuy.parentNode.insertBefore(placeholder, pdpBuy);

  const getQuantityInput = () => document.getElementById("selected-quantity");
  const getVariantInput = () => document.getElementById("selected-variant");
  const getSelectionText = () => document.querySelector(".pdp-buy .qty-selection-text");
  const getFinalPrice = () => document.querySelector(".pdp-buy .final-price");

  const syncPlacement = () => {
    if (mobileQuery.matches) {
      if (pdpBuy.parentElement !== atcSlot) {
        atcSlot.appendChild(pdpBuy);
      }
      return;
    }

    if (placeholder.parentNode && pdpBuy.parentElement !== placeholder.parentNode) {
      placeholder.parentNode.insertBefore(pdpBuy, placeholder.nextSibling);
    }
  };

  const clearActiveCards = () => {
    cards.forEach((item) => {
      item.classList.remove("is-active");
      item.setAttribute("aria-pressed", "false");
    });
  };

  const navigateToVariant = (variantId) => {
    if (!variantId) return;

    const url = new URL(window.location.href);
    if (url.searchParams.get("variant") === variantId) return;

    url.searchParams.set("variant", variantId);
    window.location.href = url.toString();
  };

  const setActiveCard = (card, options = {}) => {
    if (!card || card.disabled) return;

    cards.forEach((item) => {
      const isActive = item === card;
      item.classList.toggle("is-active", isActive);
      item.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    const quantity = card.getAttribute("data-tier-quantity") || "1";
    const variantId = card.getAttribute("data-tier-variant-id");
    const price = card.getAttribute("data-tier-price");
    const dropdownLabel = card.getAttribute("data-tier-dropdown-label");
    const dropdownDetail = card.getAttribute("data-tier-dropdown-detail");

    const quantityInput = getQuantityInput();
    if (quantityInput && selectionMode === "quantity") {
      quantityInput.value = quantity;
    }

    const variantInput = getVariantInput();
    if (selectionMode === "variant" && variantInput && variantId) {
      variantInput.value = variantId;
    }

    const finalPrice = getFinalPrice();
    if (finalPrice && price) {
      finalPrice.textContent = price;
    }

    const selectionText = getSelectionText();
    if (selectionMode === "quantity" && selectionText && dropdownLabel) {
      selectionText.textContent = dropdownLabel;
      if (dropdownDetail) {
        const detail = document.createElement("span");
        detail.className = "qty-selector-detail";
        detail.textContent = ` ${dropdownDetail}`;
        selectionText.appendChild(detail);
      }
    }

    const listbox = document.getElementById("listbox-qty");
    const option = listbox
      ? listbox.querySelector(`[data-value="${selectionMode === "variant" ? variantId : quantity}"]`)
      : null;
    if (listbox && option) {
      listbox.setAttribute("aria-activedescendant", option.id);
    }

    if (selectionMode === "variant" && options.navigate === true) {
      navigateToVariant(variantId);
    }
  };

  const syncCardFromOption = (option) => {
    if (!option) return;
    if (selectionMode === "variant" && option.getAttribute("data-variant-selector") !== "true") return;

    const value = option.getAttribute("data-value");
    const card = cards.find((item) => {
      if (selectionMode === "variant") {
        return item.getAttribute("data-tier-variant-id") === value;
      }
      return item.getAttribute("data-tier-quantity") === value;
    });

    if (card) {
      setActiveCard(card);
      return;
    }

    clearActiveCards();
  };

  cards.forEach((card) => {
    card.addEventListener("click", () => setActiveCard(card, { navigate: true }));
  });

  document.addEventListener("click", (event) => {
    const option = event.target.closest("#listbox-qty li");
    if (option) {
      syncCardFromOption(option);
    }
  });

  const selectedVariantId = getVariantInput() ? getVariantInput().value : "";
  const selectedQuantity = getQuantityInput() ? getQuantityInput().value : "1";
  const initialCard = cards.find((card) =>
    selectionMode === "variant"
      ? card.getAttribute("data-tier-variant-id") === selectedVariantId
      : card.getAttribute("data-tier-quantity") === selectedQuantity
  );

  if (initialCard) {
    setActiveCard(initialCard);
  } else {
    clearActiveCards();
  }
  syncPlacement();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncPlacement);
  } else {
    mobileQuery.addListener(syncPlacement);
  }
})();
